import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { CardBodyPropsInterface } from './types/card-body.types';

/**
 * @since 10.0.0
 */
export const CardBody = forwardRef<HTMLDivElement, CardBodyPropsInterface>(
  (props: CardBodyPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const styles = css(cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Card.Body"
        className={cx('c11n', 'c11n_card__body', styles, className)}
        {...rest}
      />
    );
  },
);

CardBody.displayName = 'Card.Body';
